import {MenuItem} from "./menu-item";

export class Menu {
    name: string;
    position: string = 'header';
    items: MenuItem[] = [];

    constructor(params: Object = {}) {
        for (let name in params) {
            this[name] = params[name];
        }
    }
}


// WEBPACK FOOTER //
// /mnt/e/apps/architect3/client/node_modules/vebto-client/core/ui/custom-menu/menu.ts